<template>
  <div>
    <Search ref="search" @on-search="onSearch" @on-reset="onReset" />

    <SearchType
      ref="searchType"
      class="search-Type"
      :data="searchTypeData"
      @change-list="changeList"
      @on-reset="onReset"
    />

    <div class="sample-list" v-loading="tableLoading">
      <SortFilterBtn
        ref="sortFilterBtn"
        :showBtnList="['xp', 'jg']"
        @change-list="sortChangeList"
      />
      <GoodBox :GoodData="tableData.list" />
      <Pagination
        :pageNo="tableParam.pageNo"
        :pageSize="tableParam.pageSize"
        :total="tableData.total"
        @handlePageChange="handlePageChange"
      />
    </div>
  </div>
</template>
<script>
import GoodBox from '@/components/GoodBox';
import Pagination from '@/components/Pagination';
import SearchType from './SearchType';
import Search from './Search';
import SortFilterBtn from '@/components/SortFilterBtn';
import { odmProductCategoryCmdsData } from '@/utils/pageInfo';

export default {
  components: { Search, SearchType, GoodBox, Pagination, SortFilterBtn },
  props: {},
  data() {
    const {
      odm_suitable_skin,
      odm_product_type,
      odm_product_efficacy,
    } = this.$store.getters.allDictListData.data;
    return {
      searchVal: '',
      tableParam: {
        pageNo: 1,
        pageSize: 10,
        data: {
          keyWords: '',
          productType: '',
          productCategory: '',
          productEfficacyList: [],
          suitableSkinList: [],
        },
      },
      searchTypeData: [
        {
          label: '产品类别',
          name: 'cplbActiveName',
          list: odm_product_type,
        },
        {
          label: '产品品类',
          name: 'cpplActiveName',
          list: [],
        },
        {
          label: '产品功效',
          name: 'cpgxActiveName',
          list: odm_product_efficacy,
          tag: 'CheckboxGroup',
          hide: true,
        },
        {
          label: '适合肤质',
          name: 'shfzActiveName',
          list: odm_suitable_skin,
          tag: 'CheckboxGroup',
        },
      ],
      tableData: {},
      tableLoading: false,
    };
  },
  mounted() {
    this.searchTypeData.find(item => item.name === 'cpplActiveName').list = 
      this.changeSelectData(odmProductCategoryCmdsData['allCategory']);
  },
  watch: {
    'tableParam.data.productType'(val) {
      if (!val) {
        this.searchTypeData.find(item => item.name === 'cpplActiveName').list = 
          this.changeSelectData(odmProductCategoryCmdsData['allCategory']);
      } else {
        this.searchTypeData.find(item => item.name === 'cpplActiveName').list = 
          this.changeSelectData(odmProductCategoryCmdsData[val]);
      }
      let data = this.tableParam.data;
      data.productEfficacyList = [];
      data.productCategory = '';
      this.searchTypeData
        .filter(item => item.name === 'cpplActiveName')
        .map(item => {
          this.$refs.searchType.$refs[item.name][0].clearRadioSelect();
        });
      this.searchTypeData
        .filter(item => item.name === 'cpgxActiveName')
        .map(item => {
          this.$refs.searchType.$refs[item.name][0].onReset();
        });
      this.searchTypeData[2].hide = val !== 'SKIN_CARE';
    },
  },
  methods: {
    changeSelectData(arr) {
      const { odm_product_category } = this.$store.getters.allDictListData.data;
      return arr.map(el => {
        return {
          label: el,
          value: odm_product_category.find(item => item.label === el).value,
        };
      });
    },
    getList() {
      this.tableLoading = true;
      this.$http.sampleApply
        .getODMListPage(this.tableParam)
        .then(result => {
          this.tableData = result.data;
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 分页
    handlePageChange({ pageNo, pageSize }) {
      this.tableParam.pageNo = pageNo;
      this.tableParam.pageSize = pageSize;
      this.getList();
    },
    inputChange(val) {
      this.tableParam.data.keyWords = val;
    },
    onSearch(val) {
      this.tableParam.data.keyWords = val;
      this.tableParam.pageNo = 1;
      this.getList();
    },
    changeList(val, name) {
      let data = this.tableParam.data;
      data.keyWords = this.$refs.search.value;
      if (name === 'cplbActiveName') {
        data.productType = val;
      }
      if (name === 'cpplActiveName') {
        data.productCategory = val;
      }
      if (name === 'cpgxActiveName') {
        data.productEfficacyList = val;
      }
      if (name === 'shfzActiveName') {
        data.suitableSkinList = val;
      }
      this.getList();
    },
    sortChangeList(name, val) {
      let data = this.tableParam.data;
      delete data.newSort;
      delete data.priceSort;
      delete data.capacitySort;
      data[name] = val;
      this.getList();
    },
    onReset() {
      let data = this.tableParam.data;
      delete data.newSort;
      delete data.priceSort;
      delete data.capacitySort;
      data.productType = '';
      data.productCategory = '';
      data.suitableSkinList = [];
      data.productEfficacyList = [];
      this.searchTypeData.map(item => {
        this.$refs.searchType.$refs[item.name][0] &&
          this.$refs.searchType.$refs[item.name][0].onReset();
      });
      this.$refs.sortFilterBtn.onReset();
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .sample-list {
  max-width: 1170px;
  .el-tabs__item {
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
  }
  .el-tabs__nav {
    height: 30px;
  }
  #tab-jg {
    padding-left: 10px !important;
  }
  #tab-rl {
    padding-right: 10px !important;
  }
}
.search-Type {
  border: 1px solid #ddd;
  padding: 0 10px 5px 10px;
  /deep/ .el-checkbox {
    margin: 0px 8px;
  }
  /deep/ .el-radio {
    margin: 3px 15px 3px -2px;
  }
}
</style>
